// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1vJrs","calendarButtons":"ClockData_calendarButtons__-PvMN"};